export default __webpack_public_path__ + "static/media/premiumBadge.62929c5f.jpg";